/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const mobile = window.matchMedia('(max-width: 767px)');
    const root = document.documentElement;
    let scrollPosition = 0;

    function closeMenu() {
        if (!navigation.classList.contains('is-open')) return;

        navigation.classList.remove('is-open');
        root.classList.remove('gh-navigation-open');
        root.style.removeProperty('--gh-navigation-scroll-top');
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            if (!mobile.matches) return;

            scrollPosition = window.scrollY;
            root.style.setProperty('--gh-navigation-scroll-top', `${-scrollPosition}px`);
            root.classList.add('gh-navigation-open');
            navigation.classList.add('is-open');
        } else {
            closeMenu();
        }
    });

    mobile.addEventListener('change', function () {
        if (!mobile.matches) closeMenu();
    });
})();

/* Accessible account menu for Ghost profile and external billing management */
(function () {
    const accountMenus = document.querySelectorAll('[data-account-menu]');

    accountMenus.forEach(function (accountMenu) {
        const trigger = accountMenu.querySelector('.gh-account-menu-trigger');
        const menu = accountMenu.querySelector('.gh-account-menu-list');
        const menuItems = Array.from(menu.querySelectorAll('[role="menuitem"]'));
        const billingAction = accountMenu.querySelector('[data-billing-account-action]');
        const paidOnlyItems = accountMenu.querySelectorAll('[data-paid-only-menu]');
        const setPaidOnlyVisibility = function (visible) {
            paidOnlyItems.forEach(function (item) {
                if (visible) {
                    item.hidden = false;
                } else {
                    item.hidden = true;
                }
                item.style.display = visible ? '' : 'none';
            });
        };

        fetch('/billing/api/account/status', {
            credentials: 'same-origin',
            headers: {'accept': 'application/json'},
        }).then(function (response) {
            if (!response.ok) throw new Error('billing account status unavailable');
            return response.json();
        }).then(function (status) {
            if (status.action === 'manage') {
                billingAction.textContent = '구독관리';
                billingAction.href = '/subscription/';
                setPaidOnlyVisibility(true);
            } else if (status.action === 'subscribe') {
                billingAction.textContent = '구독하기';
                billingAction.href = '/billing/';
                setPaidOnlyVisibility(false);
            } else {
                billingAction.textContent = '구독관리';
                billingAction.href = '/subscription/';
                setPaidOnlyVisibility(false);
            }
            billingAction.dataset.billingState = status.subscription_state || 'unknown';
        }).catch(function () {
            billingAction.textContent = '구독관리';
            billingAction.href = '/subscription/';
            billingAction.dataset.billingState = 'unknown';
            setPaidOnlyVisibility(false);
        });

        function setOpen(open, restoreFocus) {
            trigger.setAttribute('aria-expanded', String(open));
            menu.hidden = !open;
            accountMenu.classList.toggle('is-open', open);

            if (!open && restoreFocus) {
                trigger.focus();
            }
        }

        trigger.addEventListener('click', function () {
            const open = trigger.getAttribute('aria-expanded') !== 'true';
            setOpen(open, false);
        });

        trigger.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setOpen(true, false);
                menuItems[0]?.focus();
            }
        });

        accountMenu.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                setOpen(false, true);
            }
        });

        menu.addEventListener('click', function (event) {
            if (event.target.closest('[role="menuitem"]')) {
                setOpen(false, false);
            }
        });

        document.addEventListener('click', function (event) {
            if (!accountMenu.contains(event.target)) {
                setOpen(false, false);
            }
        });
    });
})();

/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
